import { render, staticRenderFns } from "./ptTableRowSoccerMMO.vue?vue&type=template&id=328a8116&lang=pug&"
import script from "./ptTableRowSoccerMMO.vue?vue&type=script&lang=js&"
export * from "./ptTableRowSoccerMMO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports